import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(token, task): Observable<any> {
    let json = JSON.stringify(task);
    let params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(`${this.url}/image/new?page=${page}`, params.toString(), { headers });
  }

  getImage(token, id): Observable<any> {
    let params = new URLSearchParams();
    params.set('authorization', token);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(`${this.url}/image/detail/${id}?page=${page}`, params.toString(), { headers });
  }

  getImagesUserType(token, id, type, father): Observable<any> {
    let params = new URLSearchParams();
    params.set('authorization', token);
    params.set('type', type);
    params.set('father', father);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this._http.post(`${this.url}/image/detailusertype/${id}?page=1`, params.toString(), { headers });
  }

  update(token, task, id): Observable<any> {
    let json = JSON.stringify(task);
    let params = new URLSearchParams();
    params.set('json', json);
    params.set('authorization', token);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(`${this.url}/image/edit/${id}?page=${page}`, params.toString(), { headers });
  }

  deleteImage(token, id): Observable<any> {
    let params = new URLSearchParams();
    params.set('authorization', token);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(`${this.url}/image/remove/${id}?page=${page}`, params.toString(), { headers });
  }

  removelistings(token, id): Observable<any> {
    let params = new URLSearchParams();
    params.set('authorization', token);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(`${this.url}/image/removelistings?page=${page}`, params.toString(), { headers });
  }
}
